export const AuthService = {
  /**
   * Obtiene el Session Token de Shopify App Bridge.
   */
  getShopifyToken: async (): Promise<string | null> => {
    if (!window.shopify?.idToken) {
      console.error("[AuthService] Shopify App Bridge not initialized");
      return null;
    }
    try {
      return await window.shopify.idToken();
    } catch (error) {
      console.error("[AuthService] Error retrieving token:", error);
      return null;
    }
  },

  /**
   * Inyecta automáticamente el token de Shopify en los Headers.
   */
  fetchAPI: async (url: string, options: RequestInit = {}) => {
    const token = await AuthService.getShopifyToken();
    const headers = new Headers(options.headers || {});

    if (token && !headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return fetch(url, { ...options, headers });
  },

  /**
   * Fast-Track: Verifica de forma ultraligera si la tienda ya está instalada y activa.
   */
  checkInstallation: async (): Promise<
    "installed" | "needs_setup" | "error"
  > => {
    try {
      const response = await AuthService.fetchAPI("/api/admin/shop");

      if (response.status === 404 || response.status === 401) {
        return "needs_setup";
      }

      if (response.status === 403) {
        const data = await response.json();
        return data.code === "SHOP_INACTIVE" ? "needs_setup" : "error";
      }

      if (!response.ok) {
        return "error";
      }

      return "installed";
    } catch (error) {
      console.error(
        "[AuthService] Network error during installation check:",
        error
      );
      return "error";
    }
  },

  /**
   * Slow-Track: Ejecuta el proceso pesado de Token Exchange y Webhooks.
   * (Solo se llama en la primera instalación o reinstalación)
   */
  runInitialSetup: async (): Promise<boolean> => {
    try {
      const response = await AuthService.fetchAPI("/api/auth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sessionToken: await AuthService.getShopifyToken(),
        }),
      });

      return response.ok;
    } catch (error) {
      console.error("[AuthService] Network error during initial setup:", error);
      return false;
    }
  },
};
